import React from "react"
import { useSelector } from "react-redux"

import { validAccounts } from "data/selectors/user"
import AccountSelect from "shared/components/AccountSelect"

import MenuRenderer from "./MenuRenderer"

import styles from "./Navigation.module.css"

export default function Navigation() {
  const { stateReady, activeAccount, activePlatform, isNavigationOpen } =
    useSelector(state => state.general)
  const accounts = useSelector(state => validAccounts(state))

  return (
    <aside
      role="navigation"
      className={`${styles.root} ${isNavigationOpen ? styles.open : ""}`}
    >
      {stateReady ? (
        <>
          <AccountSelect format="/{platform}/{account}" />

          <nav className={styles.navigation}>
            <MenuRenderer
              accounts={accounts}
              activePlatform={activePlatform}
              activeAccount={activeAccount}
            />
          </nav>
        </>
      ) : null}
    </aside>
  )
}
